import React from "react";
import { linkedinConfig } from "./linkedinAuthConfig";
import Button from '@mui/material/Button';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

/**
 * Initiates LinkedIn OAuth flow
 * @param {string} clientId - LinkedIn OAuth client ID
 * @param {string} redirectUri - Redirect URI after authentication
 * @param {string} scope - OAuth scopes to request
 */
function handleLinkedInLogin(clientId, redirectUri, scope) {
    const state = Math.random().toString(36).substring(7);
    sessionStorage.setItem('linkedin_oauth_state', state);

    const authUrl = `${linkedinConfig.authorizationEndpoint}?` +
        `response_type=code&` +
        `client_id=${encodeURIComponent(clientId)}&` +
        `redirect_uri=${encodeURIComponent(redirectUri)}&` +
        `scope=${encodeURIComponent(scope)}&` +
        `state=${encodeURIComponent(state)}`;

    window.location.href = authUrl;
}

/**
 * Renders a button which, when selected, will redirect the page to the LinkedIn login prompt
 */
export const LinkedInSignInButton = (props) => {
    return (
        <Button
            fullWidth
            variant="contained"
            {...props}
            onClick={() => handleLinkedInLogin(
                linkedinConfig.clientId,
                linkedinConfig.redirectUri,
                linkedinConfig.scope
            )}
            startIcon={<LinkedInIcon />}
            sx={{
                backgroundColor: '#0077B5',
                color: 'white',
                '&:hover': {
                    backgroundColor: '#005582'
                },
                textTransform: 'none',
                fontWeight: 'bold'
            }}
        >
            Sign in with LinkedIn
        </Button>
    );
}
